<template>
  <slot name="countdown" v-if="!isPast">
    <span v-if="format === 'span'">
      {{ countdownIntroMessage }}
      {{ timeLeft.minutes }} {{ __('countdown.minutes') }},
      {{ timeLeft.seconds }} {{ __('countdown.seconds') }}
    </span>

    <p v-else-if="format === 'paragraph'">
      {{ countdownIntroMessage }}
      {{ timeLeft.minutes }} {{ __('countdown.minutes') }},
      {{ timeLeft.seconds }} {{ __('countdown.seconds') }}
    </p>

    <div
      v-else-if="format === 'countdown'"
      class="countdown-timer"
      :class="[
        { 'countdown-timer--almost-past': isAlmostPast },
        'countdown-timer--' + size,
      ]"
    >
      <div class="countdown-timer__time-block">
        {{ timeLeft.hours }}<span class="countdown-timer__time-label">h</span>
      </div>
      <div class="countdown-timer__time-block">
        {{ timeLeft.minutes }}<span class="countdown-timer__time-label">m</span>
      </div>
      <div class="countdown-timer__time-block">
        {{ timeLeft.seconds }}<span class="countdown-timer__time-label">s</span>
      </div>
    </div>
  </slot>

  <slot name="past" v-if="isPast"></slot>
  <slot name="almost-past" v-else-if="isAlmostPast"></slot>
</template>

<script setup>
import {
  ref, computed, onMounted, onUnmounted,
} from 'vue';

const props = defineProps({
  deadline: {
    type: Number,
    required: true, // UNIX timestamp in ms
  },
  gracePeriodSeconds: {
    type: Number,
    default: 0,
  },
  format: {
    type: String,
    default: 'span', // 'span' | 'paragraph' | 'countdown'
  },
  size: {
    type: String,
    default: 'large',
  },
  countdownIntroMessage: {
    type: String,
    default: '',
  },
});

const now = ref(Date.now());

let intervalId = null;
onMounted(() => {
  intervalId = setInterval(() => {
    now.value = Date.now();
  }, 1000);
});

onUnmounted(() => {
  clearInterval(intervalId);
});

const timeLeft = computed(() => {
  const total = Math.max(0, props.deadline - now.value);
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / (1000 * 60)) % 60);
  const hours = Math.floor(total / (1000 * 60 * 60));
  return { hours, minutes, seconds };
});

const isPast = computed(() => props.deadline - now.value < 1000);
const isAlmostPast = computed(() => (props.deadline - now.value) / 1000 < props.gracePeriodSeconds);
</script>
